import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import KingBedIcon from '@mui/icons-material/KingBed';
import KingBedOutlinedIcon from '@mui/icons-material/KingBedOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import WorkOutlinedIcon from '@mui/icons-material/WorkOutlined';
import { Box } from '@mui/material';
import assistLogoBlack from '@shared/assets/assistLogoBlack.svg';
import assistLogoWhite from '@shared/assets/assistLogoWhite.svg';

export const sxStyled = ({
  theme,
  value,
  pageConfiguration,
  screenWidth,
  showDollarInfo,
  showFli,
}) => {
  const tabColorMap = {
    Vuelos: { 1: '#6FB9DB' },
    Alojamiento: { 1: '#F8A0CA' },
    Paquetes: {},
  };

  const getIconColor = (tabName, tabIndex, id) => {
    const isActive = +value === +tabIndex;

    if (!isActive) return '#636466';

    if (tabName === 'Paquetes') {
      if (+id === 1) return '#000 !important';
      return '#fff !important';
    }

    return '#fff !important';
  };

  const getTabColor = (tabName, tabIndex, id) => {
    const isActive = +value === +tabIndex;

    if (isActive) {
      const mappedColor = tabColorMap[tabName]?.[id];
      return mappedColor || theme.palette.primary.main;
    }

    if (+id === 1) return 'white';
    return '#C2E6FA';
  };

  const { id } = pageConfiguration;

  const tabSx = (tabName, tabIndex) => ({
    minWidth: 130,
    maxWidth: { xs: 'none', sm: 200 },
    flex: { xs: 'initial', sm: 1 },
    boxSizing: 'border-box',
    color: getIconColor(tabName, tabIndex, id),
    fontWeight: +value === +tabIndex ? 600 : 400,
    fontSize: { xs: 12, sm: 'inherit' }, // base, se ajustará con media queries
    backgroundColor: getTabColor(tabName, tabIndex, id),
    borderRadius: '8px 8px 0 0',
    padding: '8px 12px 6px 6px',
    textTransform: 'none',
    transition: 'none',
    display: 'flex',
    justifyContent: 'center',

    // 📱 Media queries para móviles con minWidth y fontSize adecuados
    '@media (min-width:320px)': {
      minWidth: 80,
      fontSize: '10px',
    },
    '@media (min-width:360px)': {
      minWidth: 90,
      fontSize: '11px',
    },
    '@media (min-width:375px)': {
      minWidth: 95,
      fontSize: '12px',
    },
    '@media (min-width:414px)': {
      minWidth: 105,
      fontSize: '13px',
    },
    '@media (min-width:480px)': {
      minWidth: 120,
      fontSize: '14px',
    },
    '@media (min-width:540px)': {
      minWidth: 135,
      fontSize: '14px',
    },
    '@media (min-width:600px)': {
      minWidth: 130,
      fontSize: '14px',
    },
  });

  // Configuración de tabs
  const tabsConfig = [
    { name: 'Vuelos', id: 0, show: showFli === 1, icon: 'flight' },
    { name: 'Alojamiento', id: 1, icon: 'bed' },
    { name: 'Paquetes', id: 2, icon: 'work' },
    { name: '', id: 3, icon: 'assist' },
  ];

  // Función para renderizar iconos según tab
  const renderTabIcon = tab => {
    switch (tab.icon) {
      case 'flight':
        return <FlightTakeoffIcon />;
      case 'bed':
        return value === tab.id ? <KingBedIcon /> : <KingBedOutlinedIcon />;
      case 'work':
        return value === tab.id ? (
          <WorkOutlinedIcon />
        ) : (
          <WorkOutlineOutlinedIcon />
        );
      case 'assist':
        return (
          <Box
            component="img"
            src={value === 3 ? assistLogoWhite : assistLogoBlack}
            alt="assistLogo"
            sx={{
              maxHeight: { xs: 30, sm: 60 },
              width: 'auto',
              objectFit: 'contain',
            }}
          />
        );
      default:
        return null;
    }
  };

  return {
    gridContainer: {
      background: theme.headerColor,
      px: { xs: '16px', md: '32px', lg: '116px' },
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    tabsBox: {
      display: 'flex',
      flex: 1,
      minWidth: 0,
      overflowX: 'auto',
    },
    tabs: {
      flex: 1,
      '& .MuiTabs-flexContainer': {
        justifyContent: { xs: 'center', sm: 'flex-start' },
      },
      '& .MuiTabs-indicator': {
        backgroundColor: 'transparent',
      },
    },
    tabSx,
    dollarBox: {
      ml: 2,
      mr: 2,
      display: showDollarInfo && screenWidth >= 600 ? 'block' : 'none',
    },
    tabsConfig,
    renderTabIcon,
  };
};
